import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import merge from 'lodash.merge';
import _get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import cloneDeep from 'lodash.clonedeep';
import { getURLQuery } from "./utils";

var ConfigCache = /*#__PURE__*/function () {
  function ConfigCache() {
    _classCallCheck(this, ConfigCache);

    _defineProperty(this, "cache", void 0);

    this.cache = {};
  }

  _createClass(ConfigCache, [{
    key: "bind",
    value: function bind(data) {
      merge(this.cache, data);
    }
  }, {
    key: "get",
    value: function get(key) {
      return _get(this.cache, key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache = {};
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.cache;
    }
  }]);

  return ConfigCache;
}();

export var DocsConfig = /*#__PURE__*/function () {
  function DocsConfig() {
    _classCallCheck(this, DocsConfig);

    _defineProperty(this, "cache", void 0);

    this.cache = new ConfigCache();
    this.init();
  }

  _createClass(DocsConfig, [{
    key: "bind",
    value:
    /**
     * 绑定配置数据
     * @param data 将data中的数据遍历存入缓存，如果缓存中已有相同字段原值将被覆盖
     * @example
     * ```js
     * // 缓存中已存在配置
     * titleBar: {
     *      back:true,
     *      logo:false,
     * }
     * 当data为下值时
     * { titleBar: { back:false, share:false } }
     * 最终存储的配置信息为
     * titleBar: {
     *      back:false,
     *      logo:false
     *      share:false,
     * }
     * ```
     */
    function bind(data) {
      if (!isEmpty(data)) {
        this.cache.bind(data);
      }

      this.saveToSessionStorage();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
    }
    /**
     * 获取key指定的配置项
     * @param key 例如'titleBar.back'
     * @returns 查询到的配置项，不存在时返回 undefined
     */

  }, {
    key: "getConfig",
    value: function getConfig(key) {
      var value = this.cache.get(key);

      if (_typeof(value) === 'object') {
        return cloneDeep(value);
      }

      return value;
    }
    /**
     * 获取所有配置
     * @returns 返回 cache 的副本
     */

  }, {
    key: "getAllConfig",
    value: function getAllConfig() {
      var _this$cache$getAll;

      var cache = (_this$cache$getAll = this.cache.getAll()) !== null && _this$cache$getAll !== void 0 ? _this$cache$getAll : {};
      return cloneDeep(cache);
    }
    /**
     * 将配置文件写入 sessionStorage
     * @param data
     * @returns 返回存储状态
     */

  }, {
    key: "saveToSessionStorage",
    value: function saveToSessionStorage(data) {
      try {
        if (typeof self !== 'undefined' && self.sessionStorage) {
          var _ref;

          var configData = (_ref = data !== null && data !== void 0 ? data : this.cache.getAll()) !== null && _ref !== void 0 ? _ref : {};
          self.sessionStorage.setItem('configCache', JSON.stringify(configData));
          return true;
        }
      } catch (e) {
        console.error(e);
      }

      return false;
    }
    /**
     * 从 sessionStorage 中恢复数据
     * @returns 恢复状态
     */

  }, {
    key: "loadFromSessionStorage",
    value: function loadFromSessionStorage() {
      try {
        if (typeof self !== 'undefined' && self.sessionStorage) {
          var configCache = self.sessionStorage.getItem('configCache');

          if (configCache) {
            this.bind(JSON.parse(configCache));
            return true;
          }
        } else {
          throw new Error('browser is not support sessionStorage');
        }
      } catch (e) {
        console.error(e);
      }

      return false;
    }
  }, {
    key: "init",
    value: function init() {
      // SSR 没有 window 变量
      if (typeof self === 'undefined') {
        return;
      } // 配置直出场景, 配置内联到 window.Config 字段上


      var config = self.AppConfig;

      if (_typeof(config) !== 'object') {
        console.error('加载 AppConfig 配置出错');
        return;
      }

      var mode = getURLQuery('mode');
      var json = config[mode] || config.normal;
      this.bind(json);
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new DocsConfig();
      }

      return this.instance;
    }
  }]);

  return DocsConfig;
}();

_defineProperty(DocsConfig, "instance", void 0);
//# sourceMappingURL=config-manager.js.map